import store from '@/store/index'
import service from './axios'

// 数据埋点
// 基础 api

function setburyingPoint(data) {
  return service({
    url: '/doc/data/save',
    method: 'post',
    data
  })
}

/**
 * 数据埋点对外导出 api
 * 事件类型 1.设置单人本地编辑模式次数  2.设置多人在线编辑模式次数 3.点击在线编辑  4.点击本地编辑  5.点击预览  6.点击只读打开 7.双击文件(预览、多人在线编辑，单人本地编辑)  8.单文件单次在线编辑（文件维度） 9.单文件单次在线编辑具体参与情况统计 10.单人单次本地编辑 11.单人单次只读打开  12.单文件单次预览
 * @param { Object } file 文件信息
 * @param { { eventType:'事件类型', type:'1进入/2退出'} } object 剩余参数
 * @returns
 */
export function setburyingPointInit(data) {
  const { docName, docType, loginObject, fileObject } = store.getters
  const { id, fileId, docId, updateTime, version, docSource } = fileObject
  const { orgId, crmId, loginType, projectId } = loginObject

  const obj = {
    data: {
      orgId,
      crmId,
      projectId,
      // 这里只有单击的情况
      operateType: 1,
      loginType: loginType === 'pc' ? 1 : 0,
      fileId: fileId || id,
      docId: docId,
      fileCurrCreateTime: updateTime,
      fileCurrVersion: version || 1,
      fileName: docName,
      fileType: docType,
      source: docSource,
      ...data
    }
  }
  return setburyingPoint(obj)
}


/**
 * 保存 wps 返回的日志
 * @param {*} param 
 */
function saveOperationLogApi(data) {
  return service({
    url: '/doc/online/log/saveOperationLog',
    method: 'post',
    data
  })
}

/**
 * 
 * @param { eventName，eventData } 事件回调名称、回传数据
 */
export function saveOperationLog(data) {
  const { docName, loginObject, fileObject, operationId } = store.getters
  const { id, fileId, docId,  version, docSource } = fileObject
  const { orgId, crmId, projectId } = loginObject

  const obj = {
    data: {
      operationId: operationId || null,
      orgId,
      crmId,
      projectId,
      docName,
      fileId: fileId || id,
      docId: docId,
      source: docSource,
      version: version || 1,
      timestamp: new Date().getTime(),
      ...data
    }
  }
  return saveOperationLogApi(obj)
}

// 获取当前用户加入的组织列表
export function getAllOrgList () {
  const { crmId } = store.getters.loginObject
  return service({
    url: '/global/org/selectAllOrgByCrmId',
    method: 'post',
    data: { data: crmId }
  })
}

export const burialPoint = (data) => service({
  url: '/buried/btn/batchBtnClickBuried',
  method: 'post',
  data
})

// 获取引导页
export const showGuideInfo = (data) => service({
  url: '/global/guidance/selectDetails',
  method: 'post',
  data
})

// 设置引导页
export const updateGuideInfo = (data) => service({
  url: '/global/guidance/update',
  method: 'post',
  data
})

// 获取文件路径
export const getFullPathStrById = (data) => service({
  url: '/doc/project/getFullPathStrById',
  method: 'post',
  data
})

// 白名单
export const getToolBoxPowerById = (data) => service({
  url: '/file/fileToolBox/getToolBoxPowerById',
  method: 'post',
  data
})


// WEBPACK FOOTER //
// ./src/api/system.api.js